export const environment = {
  production: false,
  apiUrl: 'https://welthy-api-dev.crio-server.com/api',
  strictPhoneFormat: false,
};
